var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckGreenCosmos = function SvgCheckGreenCosmos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009D43",
    d: "m17.195 9.469-6.164 6.164-2.25-2.274c-.117-.093-.304-.093-.398 0l-.68.68c-.094.094-.094.281 0 .399l3.14 3.117a.27.27 0 0 0 .4 0l7.03-7.032c.094-.093.094-.28 0-.398l-.68-.656c-.093-.117-.28-.117-.398 0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    x: 0.5,
    y: 0.5,
    stroke: "#009D43",
    rx: 12.5
  })));
};
export { SvgCheckGreenCosmos as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjE5NTMgOS40Njg3NUwxMS4wMzEyIDE1LjYzMjhMOC43ODEyNSAxMy4zNTk0QzguNjY0MDYgMTMuMjY1NiA4LjQ3NjU2IDEzLjI2NTYgOC4zODI4MSAxMy4zNTk0TDcuNzAzMTIgMTQuMDM5MUM3LjYwOTM4IDE0LjEzMjggNy42MDkzOCAxNC4zMjAzIDcuNzAzMTIgMTQuNDM3NUwxMC44NDM4IDE3LjU1NDdDMTAuOTYwOSAxNy42NzE5IDExLjEyNSAxNy42NzE5IDExLjI0MjIgMTcuNTU0N0wxOC4yNzM0IDEwLjUyMzRDMTguMzY3MiAxMC40Mjk3IDE4LjM2NzIgMTAuMjQyMiAxOC4yNzM0IDEwLjEyNUwxNy41OTM4IDkuNDY4NzVDMTcuNSA5LjM1MTU2IDE3LjMxMjUgOS4zNTE1NiAxNy4xOTUzIDkuNDY4NzVaIiBmaWxsPSIjMDA5RDQzIi8+CjxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHJ4PSIxMi41IiBzdHJva2U9IiMwMDlENDMiLz4KPC9zdmc+Cg==";